// Common Zod schemas used across the contract.
//
// The generic passthrough-row primitives that once lived here (`rowBaseSchema`,
// `actionResultSchema`, `listFilterSchema`) belonged to the retired generic
// logical-row / SQLite-seed model (ADR-0002) and have been removed. Each view
// contract now defines its own real `z.object` DTOs at the mapping seam
// (ADR-0003); shared presentation primitives live in their own schema modules
// (e.g. `clientStubSchema` in clients.ts).
import { z } from 'zod';

/** Standard error envelope returned by 4xx/5xx contract responses. */
export const errorBody = z.object({ error: z.string() });
/** Error envelope variant that also carries an optional machine-readable code. */
export const errorBodyWithCode = z.object({ error: z.string(), code: z.string().optional() });
